module.exports = __webpack_public_path__ + "img/195.c687a793.jpg";